export const RoutePostMerchflows_MerchflowId_StoresPogsMarkDelivered =
  "/merchflows/:merchflowId/stores/pogs/mark-delivered";

export interface ResponsePostMerchflows_MerchflowId_StoresPogsMarkDelivered {
  delivered_count: number;
  already_delivered_count: number;
  skipped_count: number;
  skipped_stores: string[];
}
